import { Grid } from "@mui/material";
import CalendarTodayOutlinedIcon from "@mui/icons-material/CalendarTodayOutlined";
import PeopleOutlineIcon from "@mui/icons-material/PeopleOutline";
import GroupsOutlinedIcon from "@mui/icons-material/GroupsOutlined";
import SpeedOutlinedIcon from "@mui/icons-material/SpeedOutlined";
import { StatCard } from "src/design";
import {
  iconBgInfo,
  iconColorInfo,
  iconBgSuccess,
  iconColorSuccess,
  iconBgPurple,
  iconColorPurple,
} from "src/design/tokens";
import { useTranslation } from "react-i18next";
import { AnalyticsOverview } from "src/data/admin/types/analytics";

const iconBgAmber = "#FEF3C7";
const iconColorAmber = "#D97706";

interface Props {
  data: AnalyticsOverview;
}

export const AnalyticsStatsRow = ({ data }: Props) => {
  const { t } = useTranslation();
  const suffix = t("analytics.stats.vsLastWeek");

  return (
    <Grid container spacing={2} sx={{ mb: 1 }}>
      <Grid item xs={12} md={6} lg={3}>
        <StatCard
          label={t("analytics.stats.totalBookings")}
          value={data.totalBookings}
          icon={<CalendarTodayOutlinedIcon sx={{ fontSize: 18 }} />}
          iconBg={iconBgInfo}
          iconColor={iconColorInfo}
          trend={data.totalBookingsTrend}
          trendSuffix={suffix}
        />
      </Grid>
      <Grid item xs={12} md={6} lg={3}>
        <StatCard
          label={t("analytics.stats.guestCount")}
          value={data.guestCount}
          icon={<PeopleOutlineIcon sx={{ fontSize: 18 }} />}
          iconBg={iconBgSuccess}
          iconColor={iconColorSuccess}
          trend={data.guestCountTrend}
          trendSuffix={suffix}
        />
      </Grid>
      <Grid item xs={12} md={6} lg={3}>
        <StatCard
          label={t("analytics.stats.avgPartySize")}
          value={data.avgPartySize}
          icon={<GroupsOutlinedIcon sx={{ fontSize: 18 }} />}
          iconBg={iconBgAmber}
          iconColor={iconColorAmber}
          trend={data.avgPartySizeTrend}
          trendSuffix={suffix}
        />
      </Grid>
      <Grid item xs={12} md={6} lg={3}>
        <StatCard
          label={t("analytics.stats.occupancyRate")}
          value={`${data.occupancyRate}%`}
          icon={<SpeedOutlinedIcon sx={{ fontSize: 18 }} />}
          iconBg={iconBgPurple}
          iconColor={iconColorPurple}
          trend={data.occupancyRateTrend}
          trendSuffix={suffix}
        />
      </Grid>
    </Grid>
  );
};
